import { RECEIVE_PROFILE } from "../actions/profile";

import { RECEIVE_USERS } from "../actions/users";

function users(state = {}, action) {
  switch (action.type) {
    case RECEIVE_PROFILE:
      return Object.assign({}, state, {
        [action.user.id]: action.user
      });

    case RECEIVE_USERS:
      const newUsers = {};
      action.users.forEach(u => (newUsers[u.id] = u));
      return Object.assign({}, state, newUsers);
    default:
      return state;
  }
}

export default users;



// WEBPACK FOOTER //
// ./src/reducers/users.js